// src/services/googleSheetsService.js
import axios from 'axios';

/**
 * Google Apps Script Web App URL
 * Replace this with your deployed script URL
 * IMPORTANT: Must end with /exec (not /dev)
 */
const GOOGLE_SCRIPT_URL = process.env.REACT_APP_MERCHANT_SIGNUP_WEBHOOK || 
  'https://script.google.com/macros/s/AKfycby_UaG9SJV7F0S71rusfFg0-vAkWJ1MrmS7zoRdJ20WkSG4_yk2A6zhnmP-1mYGezpOKQ/exec';

/**
 * Save merchant signup data to Google Sheets
 * @param {Object} data - Signup data
 * @param {string} data.merchantId - Merchant ID
 * @param {string} data.username - Username
 * @param {string} data.password - Password (consider security implications)
 * @param {string} data.parentClientId - Parent Client ID
 * @param {string} data.email - Email address
 * @param {string} data.phone - Phone number
 * @param {string} data.name - Full name
 * @param {string} data.brandName - Brand name
 * @returns {Promise<Object>} Response
 */
export const saveMerchantSignupToSheet = async (data) => {
  try {
    console.log('📊 Saving signup data to Google Sheets...');
    console.log('📤 Base URL:', GOOGLE_SCRIPT_URL);
    console.log('📤 Data:', { 
      merchantId: data.merchantId, 
      username: data.username,
      parentClientId: data.parentClientId,
      email: data.email,
      phone: data.phone,
      name: data.name,
      brandName: data.brandName
    });
    
    // Build query string for GET request
    const params = new URLSearchParams({
      merchantId: data.merchantId || '',
      username: data.username || '',
      password: data.password || '',
      parentClientId: data.parentClientId || '',
      email: data.email || '',
      phone: data.phone || '',
      name: data.name || '',
      brandName: data.brandName || '',
    });
    
    const fullUrl = `${GOOGLE_SCRIPT_URL}?${params.toString()}`;
    console.log('📤 Full URL:', fullUrl);
    
    const response = await axios.get(fullUrl, {
      timeout: 15000, // 15 seconds (increased for Google Scripts)
      headers: {
        'Accept': 'application/json',
      },
      validateStatus: function (status) {
        // Accept any status code (we'll handle it)
        return status >= 200 && status < 500;
      },
    });
    
    console.log('✅ Google Sheets response:', response.data);
    
    if (response.data?.success === false) {
      throw new Error(response.data?.error || 'Failed to save to Google Sheets');
    }
    
    return { success: true, data: response.data };
    
  } catch (error) {
    console.error('❌ Failed to save to Google Sheets:', error);
    console.error('❌ Error details:', {
      message: error.message,
      status: error.response?.status,
      data: error.response?.data,
      url: GOOGLE_SCRIPT_URL
    });
    
    // Don't throw - this is non-critical, shouldn't stop onboarding
    return { 
      success: false, 
      error: error.message || 'Failed to save to Google Sheets' 
    };
  }
};

